export default __webpack_public_path__ + "static/media/video.92ec63d5.svg";